/** True when FormData contains file blobs (cannot queue for offline replay). */
export function formDataHasFiles(fd: FormData): boolean {
 const values = Array.from(fd.values())
 for (let i = 0; i < values.length; i++) {
 const value = values[i]
 if (typeof File !== 'undefined' && value instanceof File) {
 return true
 }
 if (typeof Blob !== 'undefined' && value instanceof Blob && !(typeof File !== 'undefined' && value instanceof File)) {
 return true
 }
 }
 return false
}

/** Flat FormData without files — safe to persist in the offline mutation queue. */
export function formDataToPlainObject(fd: FormData): Record<string, string> {
 const out: Record<string, string> = {}
 fd.forEach((value, key) => {
 if (typeof File !== 'undefined' && value instanceof File) {
 throw new Error('form_data_contains_files')
 }
 if (typeof Blob !== 'undefined' && value instanceof Blob) {
 throw new Error('form_data_contains_files')
 }
 out[key] = String(value)
 })
 return out
}
